import { render, staticRenderFns } from "./LeaderBonus.vue?vue&type=template&id=bd7c7fe8&"
import script from "./LeaderBonus.vue?vue&type=script&lang=js&"
export * from "./LeaderBonus.vue?vue&type=script&lang=js&"
import style0 from "./LeaderBonus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports